(() => {
  'use strict';
  const root = document.querySelector('.pwst-foc');
  if (!root) return;
  function refreshDeadlines() {
    const now = Date.now() / 1000;
    const open = [...root.querySelectorAll('[data-foc-date]')].filter(link => Number(link.dataset.cutoff) > now);
    root.querySelectorAll('[data-foc-date]').forEach(link => { link.hidden = !open.slice(0, 8).includes(link); });
    const next = open[0]?.getAttribute('href') || '/collections/foc-current';
    root.querySelectorAll('[data-foc-next]').forEach(link => { link.href = next; });
    const deadline = root.querySelector('[data-foc-deadline]');
    if (deadline) {
      const closed = now >= Number(deadline.dataset.focDeadline);
      deadline.querySelector('[data-foc-open]').hidden = closed;
      deadline.querySelector('[data-foc-closed]').hidden = !closed;
    }
  }
  refreshDeadlines();
  setInterval(refreshDeadlines, 30000);
  document.addEventListener('visibilitychange', refreshDeadlines);
  window.addEventListener('pageshow', refreshDeadlines);
})();
